<template>
    <div id="page-menu-wrapper" class="tw-flex" :class="{'sticky': sticky_tab}" ref="tabMenu">
        <div class="main-content-inner-wrapper no-padding-top tw-max-w-full">
            <custom-form>
                <div class="menu-items-wrapper relative tw-flex tw-items-center tw-overflow-hidden tw-h-full">
                    <div class="menu-items-wrapper-inner tw-h-full">
                        <transition name="swap" mode="out-in">
                            <div class="tw-flex tw-flex-1 tw-items-center tw-h-full" v-if="!sticky_tab">
                                <slot></slot>
                                <portal-target name="tab-menu" slim></portal-target>
                            </div>
                            <div class="tw-flex tw-h-full tw-items-center tw-pr-8" key="empty" v-else>
                                <slot name="sticky"></slot>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="tw-flex tw-flex-shrink-0" v-if="$slots.actions">
                    <slot name="actions"></slot>
                </div>
            </custom-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TabMenu',

        props: {
            stickyOnScroll: {
                default: false,
                type: Boolean,
            },
        },

        data() {
            return {
                sticky_tab: false,
            };
        },

        methods: {
            addScrollListener() {
                document.addEventListener(`scroll`, this.scrolled);
            },

            scrolled() {
				if (typeof this.$refs.tabMenu !== 'undefined') {
					const offset_top = this.$refs.tabMenu.offsetTop;
					const scrolled_from_top = window.scrollY;

					if (scrolled_from_top + 70 >= offset_top) {
						if (!this.sticky_tab) {
							this.sticky_tab = true;
						}
					} else if (this.sticky_tab) {
						this.sticky_tab = false;
					}
				}
            }
        },

        beforeDestroy() {
            if (this.stickyOnScroll) {
                window.removeEventListener('scroll', this.scrolled);
            }
        },

        mounted() {
            if (this.stickyOnScroll) {
                this.addScrollListener();
            }
        },
    };
</script>

<style lang="scss">
    #page-menu-wrapper {
        @apply tw-w-full tw-bg-white;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16);
        height: 60px;

        .custom-form-wrapper {
            @apply tw-max-w-full;

            .form-content {
                @apply tw-my-0 tw-h-full;

                .form-content-flex-wrapper {
                    @apply tw-relative tw-w-full tw-h-full;

                    .form-content-inner {
                        @apply tw-flex-row tw-justify-between tw-items-center tw-max-w-full tw-h-full;

                        .menu-items-wrapper {
                            .menu-items-wrapper-inner {
                                @apply tw-overflow-scroll;

                                .tab-menu-item {
                                    .menu-item {
                                        @apply tw-flex tw-items-center tw-text-lg tw-mr-5 tw-p-3 tw-rounded tw-cursor-pointer;

                                        i {
                                            @apply tw-mr-3 tw-pt-px;
                                        }

                                        &:hover {
                                            @apply tw-bg-gray-0;
                                        }

										&:active {
											@apply tw-bg-gray-100;
										}

                                        &.disabled {
                                            @apply tw-opacity-25 tw-cursor-not-allowed tw-pointer-events-none;
                                        }

                                        @media(max-width: 767px) {
                                            @apply tw-mr-2;
                                            font-size: 1rem;
                                        }
                                    }

                                    @media(max-width: 767px) {
                                        &:last-of-type {
                                            @apply tw-pr-4;
                                        }
                                    }
                                }

                                &::-webkit-scrollbar {
                                    @apply tw-hidden;
                                }
                            }

                            &:after {
                                @apply tw-absolute tw-z-20 tw-pointer-events-none tw-right-0;
                                content: "";
                                width: 30px;
                                height: 60px;
                                bottom: -8px;
                                background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #fff 100%);
                            }
                        }

                        .action-btn-wrapper {
                            @apply tw-flex tw-items-center;

                            .clickable-icon {
                                width: 40px;
                                height: 40px;
                            }
                        }
                    }
                }

                @media(max-width: 1270px) {
                    @apply tw-max-w-full;
                }
            }

            @media(max-width: 767px) {
                @apply tw-px-3;
            }
        }

        @media(max-width: 767px) {
            height: 54px;
        }

        &.sticky {
            @apply tw-sticky;
            z-index: 11;
            top: 70px;

            @media(max-width: 1024px) {
                top: 64px;
            }
        }

       
    }

    .swap-enter-active, .swap-leave-active {
        transition: opacity .15s ease, transform .15s ease;
    }

    .swap-leave, .swap-enter-to {
        // transform: translateX(10px);
    }

    .swap-enter, .swap-leave-to {
        transform: translateY(10px);
        opacity: 0;
    }

    .break-normal {
        overflow-wrap: normal !important;
        word-break: normal !important; 
    }
</style>
